import SimpleSelect from 'components/controls/simple-select';
import styles from './sort-by.module.scss';
import type { ChangeEventHandler } from 'react';
const SortBy = ({ initialValue, options, handleChange }: IProps) => {
	return (
		<div className={styles.sortControl}>
			<span className={styles.sectionTitle}>Sort by:</span>
			<SimpleSelect
				id={'sort-by'}
				initialValue={initialValue}
				options={options}
				handleChange={handleChange}
			/>
		</div>
	);
};

export interface IProps {
	initialValue: string;
	handleChange: ChangeEventHandler<HTMLSelectElement>;
	options: { name: string; value: string; isDisabled?: boolean }[];
}

export default SortBy;
